import React, { FunctionComponent } from 'react';
import { ButtonGroup, ToggleButton } from 'react-bootstrap';

import s from './ToggleButtonGroup.module.scss';

const ToggleButtonGroup: FunctionComponent<{
  items: { id: string; title: string }[];
  onChange(value: string): void;
  value?: string;
  className: string;
}> = ({ items, onChange, value, ...props }) => {
  return (
    <div className={s.buttonGroup}>
      <ButtonGroup {...props} toggle>
        {items.length > 0 &&
          items.map(item => (
            <ToggleButton
              key={item.id}
              id={item.id}
              type="radio"
              variant={item.id === value ? 'primary' : 'white'}
              name={item.id}
              checked={item.id === value}
              onChange={e => onChange(e.currentTarget.value)}
              value={item.id}
            >
              {item.title}
            </ToggleButton>
          ))}
      </ButtonGroup>
    </div>
  );
};

export default ToggleButtonGroup;
